export const BLANK_MARKDOWN_CONTENT = '\n';
export const DEFAULT_MARKDOWN_FILENAME = 'untitled.md';

export function attachStoredAsset(command, asset) {
  if (!command?.node || !asset?.id || asset.kind !== 'markdown') {
    throw new Error('A planned Markdown idea and stored asset are required.');
  }
  const attachment = {
    assetId: asset.id,
    kind: asset.kind,
    filename: asset.filename,
    contentType: asset.contentType,
    byteSize: asset.byteSize,
    width: asset.width,
    height: asset.height,
  };
  return {
    ...command,
    node: {
      ...command.node,
      text: asset.filename,
      attachment,
    },
  };
}

export async function createStoredMarkdownIdea({
  plan,
  upload,
  execute,
  cleanup,
}) {
  const command = plan();
  let asset = null;
  try {
    asset = await upload();
    const readyCommand = attachStoredAsset(command, asset);
    const nodeId = execute(readyCommand);
    if (!nodeId) throw new Error('The Markdown idea could not be created.');
    return { asset, command: readyCommand, nodeId };
  } catch (error) {
    if (asset) {
      try {
        await cleanup(asset);
      } catch (cleanupError) {
        if (error && typeof error === 'object') error.cleanupError = cleanupError;
      }
    }
    throw error;
  }
}
